import {useContext} from 'react';
import {ProductPageContext} from 'modules/product-card/context';
import {getRedirectParamValue} from 'modules/product-card/helpers/redirect';
import {useRouter} from 'next/router';

export const useRedirectActive = () => {
    const {seo} = useContext(ProductPageContext);
    const router = useRouter();

    const sameVintage = getRedirectParamValue(router.asPath);

    return !sameVintage && Boolean(seo?.redirect?.code);
};
